/**
 * Variant PDP, time dropdown, search layout, variant grid
 * Extends window.WorkshopBookingWizardHelpers (defer after helpers.js).
 */
(function (global) {
  'use strict';
  function __amcT(s){var m=window.__AMC_I18N__;return (m&&m[s])||s;}

  var H = global.WorkshopBookingWizardHelpers;
  if (!H) return;

  var VARIANT_GRID_GAP_PX = H.VARIANT_GRID_GAP_PX;
  var VARIANT_ROW_MIN_H_PX = H.VARIANT_ROW_MIN_H_PX;
  var VARIANT_ROW_MIN_PX = H.VARIANT_ROW_MIN_PX;
  var escapeHtml = H.escapeHtml;
  var normalizeEventToSlot = H.normalizeEventToSlot;
  var slotBookable = H.slotBookable;
  var slotVisible = H.slotVisible;
  var vQtyKey = H.vQtyKey;
  var wizardViewportWidth = H.wizardViewportWidth;

  function normalizeOptionValue(val) {
    return String(val || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function styleValueFromVariant(v, styleIdx) {
    if (!v) return '';
    if (styleIdx === 0) return v.option1 || '';
    if (styleIdx === 1) return v.option2 || '';
    return v.option3 || '';
  }

  function getSectionRoot(wizardRoot, data) {
    var sid = (data && data.sectionId) || (wizardRoot && wizardRoot.getAttribute('data-section-id')) || '';
    var sectionRoot = sid ? document.getElementById('shopify-section-' + sid) : null;
    if (!sectionRoot && wizardRoot && wizardRoot.closest) {
      sectionRoot = wizardRoot.closest('[id^="shopify-section-"]');
    }
    return sectionRoot;
  }

  function isSessionOptionHandle(handle) {
    var h = String(handle || '').toLowerCase();
    return (
      h.indexOf('date') !== -1 ||
      h.indexOf('time') !== -1 ||
      h.indexOf('session') !== -1 ||
      h.indexOf('event') !== -1
    );
  }

  function parseVariantsJson(sectionRoot) {
    if (!sectionRoot) return [];
    var el = sectionRoot.querySelector('[data-variant-json]');
    if (!el || !el.textContent) return [];
    try {
      var list = JSON.parse(el.textContent);
      return Array.isArray(list) ? list : [];
    } catch (_) {
      return [];
    }
  }

  function ensureVariantMediaMeta(variant, sectionRoot, styleIdx) {
    if (!variant) return variant;
    if (variant.featured_media_id) return variant;
    var shopifyVariant = findShopifyVariantByWizard(
      sectionRoot,
      variant,
      styleIdx != null ? styleIdx : 0
    );
    if (shopifyVariant && shopifyVariant.featured_media && shopifyVariant.featured_media.id != null) {
      variant.featured_media_id = shopifyVariant.featured_media.id;
    }
    return variant;
  }

  function findShopifyVariantByWizard(sectionRoot, wizardVariant, styleIdx) {
    if (!sectionRoot || !wizardVariant) return null;
    var list = parseVariantsJson(sectionRoot);
    if (!list.length) return null;
    var idx = styleIdx != null ? Number(styleIdx) : 0;
    var styleVal = normalizeOptionValue(
      styleValueFromVariant(wizardVariant, idx) || wizardVariant.label || ''
    );
    var optKey = 'option' + (idx + 1);
    var i;
    for (i = 0; i < list.length; i++) {
      if (normalizeOptionValue(list[i][optKey]) === styleVal) return list[i];
    }
    for (i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(wizardVariant.id)) return list[i];
    }
    return null;
  }

  function findStyleFieldset(sectionRoot, styleIdx) {
    if (!sectionRoot) return null;
    var wraps = sectionRoot.querySelectorAll('.variant-input-wrap[data-handle]');
    var nonSession = [];
    var styleWrap = null;
    var i;
    for (i = 0; i < wraps.length; i++) {
      var handle = wraps[i].getAttribute('data-handle') || '';
      if (isSessionOptionHandle(handle)) continue;
      nonSession.push(wraps[i]);
      var idxAttr = wraps[i].getAttribute('data-index') || '';
      var num = parseInt(String(idxAttr).replace(/\D/g, ''), 10) - 1;
      if (num === styleIdx) styleWrap = wraps[i];
    }
    if (!styleWrap && nonSession.length) {
      styleWrap = nonSession[styleIdx] || nonSession[0];
    }
    return styleWrap;
  }

  function getProductContainer(sectionRoot, sectionId) {
    if (!sectionRoot) return null;
    if (sectionId) {
      var byId = sectionRoot.querySelector('#ProductSection-' + sectionId);
      if (byId) return byId;
    }
    return (
      sectionRoot.querySelector('[data-section-type="product"]') ||
      sectionRoot.querySelector('.product-section') ||
      sectionRoot
    );
  }

  function goToImpulseVariantMedia(sectionRoot, shopifyVariant) {
    if (!sectionRoot || !shopifyVariant) return false;
    var mediaId =
      (shopifyVariant.featured_media && shopifyVariant.featured_media.id) ||
      shopifyVariant.featured_media_id;
    if (!mediaId && shopifyVariant.featured_image && shopifyVariant.featured_image.id) {
      mediaId = shopifyVariant.featured_image.id;
    }
    if (!mediaId) return false;
    mediaId = String(mediaId);

    var sectionIdMatch = (sectionRoot.id || '').match(/^shopify-section-(.+)$/);
    var sectionId = sectionIdMatch ? sectionIdMatch[1] : '';
    if (!sectionId) {
      var mediaHost = sectionRoot.querySelector('[id^="x-product-"]');
      if (mediaHost && mediaHost.id) sectionId = String(mediaHost.id).replace(/^x-product-/, '');
    }
    if (!sectionId) return false;

    /* Media id is numeric — querySelector('.123-section') throws; match Impulse (getElementsByClassName). */
    var mediaClass = mediaId + '-' + sectionId;
    var slide = null;
    var byClass = sectionRoot.getElementsByClassName(mediaClass);
    /*
     * Theme liquid duplicates selected variant featured at the START of the list.
     * Prefer the last match so we land on the natural gallery position, not the clone.
     */
    if (byClass && byClass.length) slide = byClass[byClass.length - 1];
    if (!slide) {
      var slides = sectionRoot.querySelectorAll(
        '#media_product-' +
          sectionId +
          ' [data-media-id="' +
          sectionId +
          '-' +
          mediaId +
          '"], [data-media-id="' +
          sectionId +
          '-' +
          mediaId +
          '"].splide__slide'
      );
      if (slides && slides.length) slide = slides[slides.length - 1];
    }

    var slider = document.getElementById('x-product-' + sectionId);
    if (slider && slider.splide && slide) {
      var indexAttr = slide.getAttribute('index');
      var index = Number(indexAttr);
      if (!Number.isFinite(index) && slide.getAttribute('x-slide-index') != null) {
        index = Number(slide.getAttribute('x-slide-index')) - 1;
      }
      if (Number.isFinite(index)) {
        try {
          slider.splide.go(index);
        } catch (_) {}
        return true;
      }
    }

    /* Do not thumb.click() — Impulse handlers prepend/reorder media. */
    var stacked = document.getElementById('postion-image-' + sectionId + '-' + mediaId);
    if (stacked && typeof stacked.scrollIntoView === 'function') {
      stacked.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return true;
    }

    return false;
  }

  function parseZoomThumbMediaId(el, sectionId) {
    if (!el) return '';
    var sid = String(sectionId || '');
    var idAttr = String(el.id || '');
    var prefix = 'x-zoom-thumbnail-' + sid + '-';
    if (sid && idAttr.indexOf(prefix) === 0) return idAttr.slice(prefix.length);
    var p2 = 'x-thumbnail-' + sid + '-';
    if (sid && idAttr.indexOf(p2) === 0) return idAttr.slice(p2.length);
    var dm = String(el.getAttribute('data-media-id') || '');
    if (dm) {
      var mZoom = dm.match(/^zoom-(\d+)$/);
      if (mZoom) return mZoom[1];
      if (sid) {
        var pref = 'zoom-' + sid + '-';
        if (dm.indexOf(pref) === 0) return dm.slice(pref.length);
        var pref2 = sid + '-';
        if (dm.indexOf(pref2) === 0) return dm.slice(pref2.length);
      }
      var mTail = dm.match(/(\d+)$/);
      if (mTail) return mTail[1];
    }
    if (sid && el.className) {
      var classMatch = String(el.className).match(new RegExp('(?:^|\\s)(\\d+)-' + sid.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:\\s|$)'));
      if (classMatch) return classMatch[1];
    }
    return '';
  }

  function parseZoomSlideMediaId(slideEl, sectionId) {
    if (!slideEl) return '';
    var direct = parseZoomThumbMediaId(slideEl, sectionId);
    if (direct) return direct;
    var tagged = slideEl.querySelector('[data-media-id]');
    if (tagged) {
      var fromTagged = parseZoomThumbMediaId(tagged, sectionId);
      if (fromTagged) return fromTagged;
    }
    var host = slideEl.closest && slideEl.closest('[id$="-image-zoom-' + sectionId + '"]');
    if (host) {
      var inner = host.querySelector('[data-media-id]');
      if (inner) {
        var fromHost = parseZoomThumbMediaId(inner, sectionId);
        if (fromHost) return fromHost;
      }
    }
    return '';
  }

  /** Move zoom modal gallery only — never touch main PDP order. */
  function goToZoomGalleryByMediaId(sectionId, mediaId) {
    if (!sectionId || !mediaId) return false;
    mediaId = String(mediaId);
    var gallery = document.getElementById('media-gallery-' + sectionId);
    if (!gallery || !gallery.splide) return false;
    var thumbsRoot = document.getElementById('x-zoom-thumbnail-' + sectionId);
    var thumbs = thumbsRoot ? thumbsRoot.getElementsByClassName('x-thumbnail') : [];
    var first = -1;
    var last = -1;
    var i;
    for (i = 0; i < thumbs.length; i++) {
      if (parseZoomThumbMediaId(thumbs[i], sectionId) === mediaId) {
        if (first < 0) first = i;
        last = i;
      }
    }
    if (first < 0) return false;
    /* Skip liquid clone at index 0 when the same media also exists later. */
    var idx = first === 0 && last > 0 ? last : first;
    try {
      gallery.splide.go(idx);
      return true;
    } catch (_) {
      return false;
    }
  }

  function findImpulseMediaSlide(sectionRoot, mediaId) {
    if (!sectionRoot || !mediaId) return null;
    mediaId = String(mediaId);
    var sectionIdMatch = (sectionRoot.id || '').match(/^shopify-section-(.+)$/);
    var sectionId = sectionIdMatch ? sectionIdMatch[1] : '';
    if (!sectionId) {
      var mediaHost = sectionRoot.querySelector('[id^="x-product-"]');
      if (mediaHost && mediaHost.id) sectionId = String(mediaHost.id).replace(/^x-product-/, '');
    }
    if (!sectionId) return null;
    var byClass = sectionRoot.getElementsByClassName(mediaId + '-' + sectionId);
    if (byClass && byClass.length) return byClass[byClass.length - 1];
    var nodes = sectionRoot.querySelectorAll(
      '#media_product-' +
        sectionId +
        ' [data-media-id="' +
        sectionId +
        '-' +
        mediaId +
        '"], [data-media-id="' +
        sectionId +
        '-' +
        mediaId +
        '"].splide__slide'
    );
    if (nodes && nodes.length) return nodes[nodes.length - 1];
    return null;
  }

  function resolveImpulseMediaZoomPosition(sectionId, mediaId) {
    if (!sectionId || !mediaId) return null;
    mediaId = String(mediaId);
    var modal = document.getElementById('ProductModal-' + sectionId);
    if (modal) {
      var scoped =
        modal.querySelector('[data-media-id="zoom-' + mediaId + '"]') ||
        modal.querySelector('[data-media-id="zoom-' + sectionId + '-' + mediaId + '"]');
      var host = scoped
        ? scoped.closest('[id$="-image-zoom-' + sectionId + '"]') || scoped
        : null;
      if (host && host.id) {
        var fromHost = String(host.id).match(/^(\d+)-image-zoom-/);
        if (fromHost) return fromHost[1];
      }
      var zoomNodes = modal.querySelectorAll('[id$="-image-zoom-' + sectionId + '"]');
      for (var zi = 0; zi < zoomNodes.length; zi++) {
        var zn = zoomNodes[zi];
        if (
          zn.querySelector('[data-media-id*="' + mediaId + '"]') ||
          (zn.className && String(zn.className).indexOf(mediaId) !== -1)
        ) {
          var fromZn = String(zn.id).match(/^(\d+)-image-zoom-/);
          if (fromZn) return fromZn[1];
        }
      }
    }
    var slide = null;
    var byClass = document.getElementsByClassName(mediaId + '-' + sectionId);
    if (byClass && byClass.length) slide = byClass[0];
    if (!slide) {
      slide = document.querySelector('[data-media-id="' + sectionId + '-' + mediaId + '"]');
    }
    if (slide) {
      var xsi = slide.getAttribute('x-slide-index');
      if (xsi != null && String(xsi).trim() !== '') return String(xsi);
      var idxAttr = slide.getAttribute('index');
      if (idxAttr != null && Number.isFinite(Number(idxAttr))) return String(Number(idxAttr) + 1);
    }
    return null;
  }

  function raiseImpulseProductModal(sectionId) {
    var modal = document.getElementById('ProductModal-' + sectionId);
    if (!modal) return null;
    modal.style.setProperty('z-index', '2147483646', 'important');
    return modal;
  }

  function openImpulseProductZoom(sectionRoot, shopifyVariant) {
    if (!sectionRoot || !shopifyVariant || !window.Alpine) return false;
    var mediaId =
      (shopifyVariant.featured_media && shopifyVariant.featured_media.id) ||
      shopifyVariant.featured_media_id;
    if (!mediaId && shopifyVariant.featured_image && shopifyVariant.featured_image.id) {
      mediaId = shopifyVariant.featured_image.id;
    }
    if (!mediaId) return false;
    mediaId = String(mediaId);

    var sectionIdMatch = (sectionRoot.id || '').match(/^shopify-section-(.+)$/);
    var sectionId = sectionIdMatch ? sectionIdMatch[1] : '';
    if (!sectionId) {
      var mediaHostProbe = sectionRoot.querySelector('[id^="product-media-"]');
      if (mediaHostProbe && mediaHostProbe.id) {
        sectionId = String(mediaHostProbe.id).replace(/^product-media-/, '');
      }
    }
    if (!sectionId) return false;

    if (!document.getElementById('ProductModal-' + sectionId)) return false;

    var mediaHost = document.getElementById('product-media-' + sectionId);
    if (!mediaHost) return false;
    var alpine = null;
    try {
      alpine = window.Alpine.$data(mediaHost);
    } catch (_) {
      alpine = null;
    }
    if (!alpine || typeof alpine.zoomOpen !== 'function') return false;

    /* Do not move/reorder main PDP gallery on zoom open. */
    var slide = findImpulseMediaSlide(sectionRoot, mediaId);
    var zoomBtn = slide && slide.querySelector('button[aria-label="Image zoom"]');
    var modal = raiseImpulseProductModal(sectionId);
    var isSplide = !!(modal && modal.querySelector('[id^="media-gallery-"]'));
    var position =
      (shopifyVariant.featured_media && shopifyVariant.featured_media.position) ||
      resolveImpulseMediaZoomPosition(sectionId, mediaId);

    function landOnZoomMedia() {
      goToZoomGalleryByMediaId(sectionId, mediaId);
    }

    function invoke() {
      raiseImpulseProductModal(sectionId);
      var openedOk = false;
      if (position == null) {
        position = resolveImpulseMediaZoomPosition(sectionId, mediaId);
      }
      if (position != null) {
        try {
          alpine.zoomOpen(String(position), isSplide);
          openedOk = true;
        } catch (_) {}
      }
      if (!openedOk && zoomBtn) {
        try {
          zoomBtn.click();
          openedOk = !!alpine.zoomIsOpen;
        } catch (_) {}
      }
      if (openedOk) {
        landOnZoomMedia();
        window.setTimeout(landOnZoomMedia, 80);
        window.setTimeout(landOnZoomMedia, 220);
      }
      return openedOk;
    }

    var opened = invoke();
    if (!opened) {
      window.setTimeout(invoke, 120);
      window.setTimeout(invoke, 280);
    }
    return true;
  }

  function closeImpulseProductZoom(sectionId) {
    if (!sectionId || !window.Alpine) return false;
    var mediaHost = document.getElementById('product-media-' + sectionId);
    if (!mediaHost) return false;
    var alpine = null;
    try {
      alpine = window.Alpine.$data(mediaHost);
    } catch (_) {
      alpine = null;
    }
    if (!alpine || typeof alpine.zoomClose !== 'function') return false;
    try {
      alpine.zoomClose();
      return true;
    } catch (_) {
      return false;
    }
  }

  function openWizardVariantImageFallback(imgUrl) {
    if (!imgUrl) return false;
    var existing = document.querySelector('[data-wbw-image-zoom]');
    if (existing) existing.remove();
    var overlay = document.createElement('div');
    overlay.className = 'wbw-image-zoom';
    overlay.setAttribute('data-wbw-image-zoom', '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image zoom');
    overlay.innerHTML =
      '<button type="button" class="wbw-image-zoom__close" aria-label="Close">&times;</button>' +
      '<img class="wbw-image-zoom__img" src="' +
      escapeHtml(imgUrl) +
      '" alt="">';
    function close() {
      overlay.remove();
      document.removeEventListener('keydown', onKey);
      document.dispatchEvent(new CustomEvent('wbw:image-zoom-closed'));
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.wbw-image-zoom__close')) close();
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(overlay);
    return true;
  }

  function syncImpulseStyleOption(sectionRoot, styleIdx, styleVal) {
    if (!sectionRoot || !styleVal) return false;
    var fieldset = findStyleFieldset(sectionRoot, styleIdx);
    if (!fieldset) return false;
    var want = normalizeOptionValue(styleVal);
    var inputs = fieldset.querySelectorAll('[data-variant-input]');
    var target = null;
    inputs.forEach(function (input) {
      if (normalizeOptionValue(input.value) === want) target = input;
    });
    if (!target) return false;
    inputs.forEach(function (input) {
      input.checked = input === target;
    });
    target.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function syncImpulseOptionsByVariant(sectionRoot, shopifyVariant, options) {
    if (!sectionRoot || !shopifyVariant) return false;
    var fireChange = !!(options && options.fireChange);
    var optKeys = ['option1', 'option2', 'option3'];
    var fired = false;
    var lastChecked = null;
    for (var oi = 0; oi < optKeys.length; oi++) {
      var ok = optKeys[oi];
      var oval = shopifyVariant[ok];
      if (oval == null || String(oval).trim() === '') continue;
      var radios = sectionRoot.querySelectorAll(
        'input[type="radio"][data-variant-input][data-index="' + ok + '"]'
      );
      if (!radios || !radios.length) continue;
      radios.forEach(function (inp) {
        var isMatch = String(inp.value) === String(oval);
        inp.checked = isMatch;
        if (isMatch) lastChecked = inp;
      });
    }
    /* Firing change makes Impulse prepend/reorder gallery media — keep off unless asked. */
    if (fireChange && lastChecked) {
      lastChecked.dispatchEvent(new Event('change', { bubbles: true }));
      fired = true;
    }
    return fired;
  }

  function syncImpulseMasterVariantId(sectionRoot, shopifyVariant, options) {
    if (!sectionRoot || !shopifyVariant || shopifyVariant.id == null) return false;
    var fireChange = !!(options && options.fireChange);
    var vid = String(shopifyVariant.id);
    var changed = false;
    sectionRoot
      .querySelectorAll(
        'form[id*="product-form-"] input[name="id"], form[id*="product-form-"] select[name="id"]'
      )
      .forEach(function (el) {
        if (!el) return;
        if (String(el.value) !== vid) {
          el.value = vid;
          changed = true;
        }
        if (fireChange) {
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    var masterSelect = sectionRoot.querySelector(
      'select[data-product-select], form.product-single__form select[name="id"]'
    );
    if (masterSelect && String(masterSelect.value) !== vid) {
      masterSelect.value = vid;
      changed = true;
      if (fireChange) {
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    return changed;
  }

  function syncVariantToPdp(wizardRoot, data, variant, options) {
    if (!variant) return;
    var opts = options || {};
    /* Default false: Impulse change handlers prepend selected media and scramble gallery order. */
    var fireOptionChange = opts.fireOptionChange === true;
    var sectionRoot = getSectionRoot(wizardRoot, data);
    if (!sectionRoot) return;
    var sectionId = (data && data.sectionId) || wizardRoot.getAttribute('data-section-id') || '';
    var styleIdx =
      data && data.styleOptionIndex != null ? Number(data.styleOptionIndex) : 0;
    var styleVal =
      styleValueFromVariant(variant, styleIdx) || variant.label || '';
    var productEl = getProductContainer(sectionRoot, sectionId);
    var shopifyVariant = findShopifyVariantByWizard(sectionRoot, variant, styleIdx);

    var firedVariantInputs = false;
    if (shopifyVariant) {
      firedVariantInputs = syncImpulseOptionsByVariant(sectionRoot, shopifyVariant, {
        fireChange: fireOptionChange,
      });
      syncImpulseMasterVariantId(sectionRoot, shopifyVariant, {
        fireChange: fireOptionChange,
      });
    } else if (productEl && styleVal && fireOptionChange) {
      firedVariantInputs = syncImpulseStyleOption(productEl, styleIdx, styleVal);
    }

    variant = ensureVariantMediaMeta(variant, sectionRoot, styleIdx);
    var mediaTarget = shopifyVariant || {
      featured_media: variant.featured_media_id ? { id: variant.featured_media_id } : null,
      featured_media_id: variant.featured_media_id,
      featured_image: variant.image_url ? { src: variant.image_url } : null,
      id: variant.id,
    };
    if (mediaTarget && (mediaTarget.featured_media || mediaTarget.featured_media_id)) {
      goToImpulseVariantMedia(sectionRoot, mediaTarget);
      window.setTimeout(function () {
        goToImpulseVariantMedia(sectionRoot, mediaTarget);
      }, 120);
      if (!firedVariantInputs) {
        window.setTimeout(function () {
          goToImpulseVariantMedia(sectionRoot, mediaTarget);
        }, 260);
      }
    }
  }

  var timeDdPortalEl = null;

  function cleanupOrphanTimeDdPanels() {
    document.querySelectorAll('[data-wbw-time-dd-portal]').forEach(function (el) {
      el.remove();
    });
    timeDdPortalEl = null;
  }

  function ensureTimeDdPortal() {
    if (!timeDdPortalEl || !timeDdPortalEl.parentNode) {
      timeDdPortalEl = document.createElement('div');
      timeDdPortalEl.className = 'wbw-time-dd-portal';
      timeDdPortalEl.setAttribute('data-wbw-time-dd-portal', '');
      document.body.appendChild(timeDdPortalEl);
    }
    return timeDdPortalEl;
  }

  function getCalTimeDdParts(root) {
    var dd = root.querySelector('[data-wbw-cal-time-dd]');
    if (!dd) return null;
    var btn = dd.querySelector('[data-wbw-cal-time-dd-btn]');
    var panel = dd.querySelector('[data-wbw-cal-time-dd-panel]');
    if (!panel && timeDdPortalEl) {
      panel = timeDdPortalEl.querySelector('[data-wbw-cal-time-dd-panel]');
    }
    if (!panel) {
      var portal = document.querySelector('[data-wbw-time-dd-portal]');
      if (portal) panel = portal.querySelector('[data-wbw-cal-time-dd-panel]');
    }
    return { dd: dd, btn: btn, panel: panel };
  }

  function positionTimeDdPanel(parts) {
    if (!parts || !parts.panel || !parts.btn) return;
    var rect = parts.btn.getBoundingClientRect();
    var panel = parts.panel;
    var gap = 6;
    var maxH = 240;
    var spaceBelow = window.innerHeight - rect.bottom - gap;
    var spaceAbove = rect.top - gap;
    var openUp = spaceBelow < 120 && spaceAbove > spaceBelow;
    var avail = openUp ? spaceAbove : spaceBelow;
    panel.style.position = 'fixed';
    panel.style.left = rect.left + 'px';
    panel.style.width = Math.max(rect.width, 200) + 'px';
    panel.style.right = 'auto';
    panel.style.margin = '0';
    panel.style.zIndex = '2147483005';
    panel.style.maxHeight = Math.min(maxH, Math.max(80, avail - 8)) + 'px';
    if (openUp) {
      panel.style.top = 'auto';
      panel.style.bottom = window.innerHeight - rect.top + gap + 'px';
    } else {
      panel.style.bottom = 'auto';
      panel.style.top = rect.bottom + gap + 'px';
    }
  }

  function resetTimeDdPanelStyle(panel) {
    if (!panel) return;
    panel.style.position = '';
    panel.style.top = '';
    panel.style.bottom = '';
    panel.style.left = '';
    panel.style.width = '';
    panel.style.right = '';
    panel.style.maxHeight = '';
    panel.style.zIndex = '';
    panel.style.margin = '';
  }

  function bindTimeDdReposition(wizardRoot) {
    if (wizardRoot.__wbwTimeDdReflowBound) return;
    wizardRoot.__wbwTimeDdReflowBound = true;
    function onReflow() {
      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts || !parts.dd.classList.contains('is-open')) return;
      if (parts.panel && !parts.panel.hidden) positionTimeDdPanel(parts);
    }
    window.addEventListener('resize', onReflow, { passive: true });
    window.addEventListener('scroll', onReflow, { passive: true, capture: true });
  }

  function wbwEmitVenueReset(bookingRoot) {
    try {
      document.dispatchEvent(
        new CustomEvent('wbw:venue-reset', { detail: { bookingRoot: bookingRoot || null } })
      );
    } catch (_) {}
  }

  function bindWizardSearchLayout(bookingRoot) {
    if (!bookingRoot || bookingRoot.__wbwSearchLayoutBound) return;
    bookingRoot.__wbwSearchLayoutBound = true;

    function injectPlaceShadowStyles(place) {
      if (!place || !place.shadowRoot) return;
      var styleId = 'wbw-place-autocomplete-styles';
      if (place.shadowRoot.getElementById(styleId)) return;
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = [
        ':host {',
        '  border: none !important;',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '  background: transparent !important;',
        '  display: block !important;',
        '  width: 100% !important;',
        '}',
        'svg, [part="leading-icon"], [class*="leading-icon"], [class*="prefix-icon"], slot[name="icon"], [slot="input-icon"] {',
        '  display: none !important;',
        '  width: 0 !important;',
        '  height: 0 !important;',
        '  opacity: 0 !important;',
        '  pointer-events: none !important;',
        '}',
        'input, input:focus, input:focus-visible {',
        '  border: none !important;',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '  background: transparent !important;',
        '  appearance: none !important;',
        '  -webkit-appearance: none !important;',
        '}',
        'div, form, [class*="container"], [class*="wrapper"], [class*="input"], [class*="field"] {',
        '  border: none !important;',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '  background: transparent !important;',
        '}',
        '*:focus, *:focus-within, *:focus-visible {',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '}'
      ].join('\n');
      place.shadowRoot.appendChild(style);
    }

    function styleGooglePlaceField(place) {
      if (!place) return;
      try {
        place.setAttribute('no-input-icon', '');
        place.noInputIcon = true;
      } catch (_) {}
      try {
        place.style.setProperty('color-scheme', 'light');
        place.style.setProperty('border', 'none');
        place.style.setProperty('border-radius', '0');
        place.style.setProperty('--gmp-mat-color-surface', 'transparent');
        place.style.setProperty('--gmp-mat-color-on-surface', '#111827');
        place.style.setProperty('--gmp-mat-color-on-surface-variant', '#6b7280');
        place.style.setProperty('outline', 'none');
        place.style.setProperty('box-shadow', 'none');
        place.style.setProperty('background', 'transparent');
        place.style.setProperty('background-color', 'transparent');
      } catch (_) {}
      injectPlaceShadowStyles(place);
      try {
        if (place.shadowRoot) {
          place.shadowRoot.querySelectorAll('label, [class*="label"]').forEach(function (el) {
            el.style.setProperty('display', 'none', 'important');
          });
          place.shadowRoot.querySelectorAll('svg, [part="leading-icon"], [class*="leading-icon"], [class*="prefix-icon"], [slot="input-icon"]').forEach(function (el) {
            el.style.setProperty('display', 'none', 'important');
            el.style.setProperty('width', '0', 'important');
            el.style.setProperty('height', '0', 'important');
            el.style.setProperty('opacity', '0', 'important');
          });
          place.shadowRoot.querySelectorAll('*').forEach(function (el) {
            try {
              el.style.setProperty('border', 'none', 'important');
              el.style.setProperty('outline', 'none', 'important');
              el.style.setProperty('box-shadow', 'none', 'important');
            } catch (_) {}
          });
        }
        var inner = place.shadowRoot && place.shadowRoot.querySelector('input');
        if (inner) {
          inner.style.setProperty('width', '100%');
          inner.style.setProperty('min-height', '52px');
          inner.style.setProperty('height', '52px');
          inner.style.setProperty('box-sizing', 'border-box');
          inner.style.setProperty('padding-left', '0');
          inner.style.setProperty('padding-right', '0');
          inner.style.setProperty('border', 'none');
          inner.style.setProperty('outline', 'none');
          inner.style.setProperty('background', 'transparent');
          inner.style.setProperty('box-shadow', 'none');
          inner.style.setProperty('font-size', '15px');
          inner.style.setProperty('line-height', '52px');
          if (!inner.getAttribute('placeholder')) {
            inner.setAttribute('placeholder', 'Find your Artmaster class');
          }
        }
      } catch (_) {}
    }

    function bindSearchTrigger(wrap) {
      if (!wrap) return;
      var btn = wrap.querySelector('[data-workshop-search-default]');
      if (!btn || btn.__wbwSearchTriggerBound) return;
      btn.__wbwSearchTriggerBound = true;
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (typeof bookingRoot.__wbTriggerDefaultPrefetch === 'function') {
          bookingRoot.__wbTriggerDefaultPrefetch({ force: true });
          return;
        }
        try {
          bookingRoot.dispatchEvent(new CustomEvent('wbw:search-default', { bubbles: true }));
        } catch (_) {}
      });
    }

    function apply() {
      var panel = bookingRoot.querySelector('.wb-search-panel');
      var wrap = bookingRoot.querySelector('.wb-search-input-wrap');
      if (!wrap) return;
      var anchor = panel || wrap;
      var rect = anchor.getBoundingClientRect();
      var w = rect.width || wrap.getBoundingClientRect().width;

      var place = wrap.querySelector('gmp-place-autocomplete,[data-workshop-place-autocomplete],.wbw-search-place-host');
      var nativeInput = wrap.querySelector('#workshop-location-input');

      if (place) {
        wrap.classList.add('wbw-search-has-place');
        styleGooglePlaceField(place);
        if (nativeInput) nativeInput.classList.add('wbw-search-native-hidden');
      } else {
        wrap.classList.remove('wbw-search-has-place');
        if (nativeInput) nativeInput.classList.remove('wbw-search-native-hidden');
      }

      if (w) {
        try {
          document.querySelectorAll('.pac-container').forEach(function (pac) {
            pac.style.width = w + 'px';
            pac.style.minWidth = w + 'px';
            pac.style.maxWidth = w + 'px';
            if (rect.left) pac.style.left = rect.left + window.scrollX + 'px';
          });
        } catch (_) {}
      }

      bindSearchTrigger(wrap);
    }

    bookingRoot.addEventListener('wbw:places-mounted', apply);
    apply();
    window.addEventListener('resize', apply, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      var wrap = bookingRoot.querySelector('.wb-search-input-wrap');
      if (wrap) {
        var ro = new ResizeObserver(apply);
        ro.observe(wrap);
        bookingRoot.__wbwSearchRo = ro;
      }
    }
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        apply();
      });
      mo.observe(bookingRoot, { childList: true, subtree: true });
      bookingRoot.__wbwSearchMo = mo;
    }
    window.setTimeout(apply, 400);
    window.setTimeout(apply, 1200);
    window.setTimeout(apply, 2500);
    window.setTimeout(apply, 5000);
  }

  function venueHasBookableEvents(venue) {
    var evs = venue && Array.isArray(venue.events) ? venue.events : [];
    for (var i = 0; i < evs.length; i++) {
      var s = normalizeEventToSlot(evs[i]);
      if (s && s.date_key && slotBookable(s)) return true;
    }
    return false;
  }

  function venueHasVisibleEvents(venue) {
    if (!venue) return false;
    if (venue._wbWaitlistVenue === true) return false;
    var evs = Array.isArray(venue.events) ? venue.events : [];
    for (var i = 0; i < evs.length; i++) {
      var s = normalizeEventToSlot(evs[i]);
      if (s && s.date_key && slotVisible(s)) return true;
    }
    return false;
  }

  function venueIsWaitlistOnly(venue, card) {
    if (venue && venue.has_events === true) return false;
    if (venue && Array.isArray(venue.events) && venue.events.length > 0) return false;
    if (venue && Number(venue.events_count) > 0) return false;
    if (venue && venue.next_date_key && String(venue.next_date_key).trim()) return false;
    if (card && card.getAttribute('data-wb-waitlist-venue') === '1') return true;
    if (venue && venue._wbWaitlistVenue === true) return true;
    if (venue && venue.has_events === false) return true;
    return true;
  }

  function variantCardLayout(root) {
    var layout = root && root.getAttribute('data-wbw-variant-layout');
    return layout === 'horizontal' ? 'horizontal' : 'stacked';
  }

  function wbwAddonDisplayTitle(root) {
    var t = (root && root.getAttribute('data-addon-title')) || 'Turkish Coffee';
    t = String(t).trim();
    t = t.replace(/^traditional\s+/i, '').trim();
    return t || 'Turkish Coffee';
  }

  function isMobileViewport() {
    return wizardViewportWidth() < 750;
  }

  function isDesktopViewport() {
    return wizardViewportWidth() >= 990;
  }

  function variantGridColsCap(root, count, width) {
    var useDesktop = wizardViewportWidth() >= 990;
    var inWizard =
      root &&
      root.getAttribute &&
      root.getAttribute('data-workshop-booking-wizard') != null;
    if (inWizard && isMobileViewport()) return Math.min(count, 2);
    if (inWizard && wizardViewportWidth() >= 750) {
      return Math.min(count, 4);
    }
    var raw = root.getAttribute(useDesktop ? 'data-wbw-cols-desktop' : 'data-wbw-cols-mobile');
    var n = parseInt(String(raw), 10);
    var cap = useDesktop ? 4 : 3;
    if (Number.isFinite(n) && n >= 2) cap = Math.min(5, n);
    if (!useDesktop && width > 0 && width < 300) cap = Math.min(cap, 3);
    return Math.min(count, cap);
  }

  function pickStackedGridColumns(count, width, height, gap, root) {
    var cap = variantGridColsCap(root, count, width);
    var minColPx = wizardViewportWidth() >= 990 ? 72 : 64;
    while (cap > 2 && width > 0 && cap * minColPx > width + 6) cap -= 1;
    return Math.max(1, cap);
  }

  function variantGridGapPx() {
    if (isDesktopViewport()) return 10;
    return 4;
  }

  function stackedThumbPx(cols, width, height, count, gap, wizardRoot) {
    var mobile = isMobileViewport();
    var desktop = isDesktopViewport();
    var rows = Math.ceil(count / cols);
    var g = gap >= 0 ? gap : variantGridGapPx();
    var colW = width > 0 ? (width - g * Math.max(0, cols - 1)) / cols : 100;
    var inWizard =
      wizardRoot &&
      wizardRoot.getAttribute &&
      wizardRoot.getAttribute('data-workshop-booking-wizard') != null;
    var qtyReserve = inWizard ? 0 : desktop ? 28 : 26;
    var innerPad = desktop ? 8 : 12;
    var cardW = Math.max(44, colW - qtyReserve);
    var thumbByW;
    if (desktop) {
      thumbByW = Math.max(56, Math.floor(cardW));
    } else {
      var maxThumb = inWizard && mobile ? 86 : mobile ? 56 : 64;
      var minThumb = cols >= 4 ? 32 : 36;
      thumbByW = Math.max(minThumb, Math.min(maxThumb, Math.floor(colW - 30)));
      if (inWizard) thumbByW = Math.min(thumbByW, mobile ? 86 : 88);
    }
    if (height <= 0 || rows <= 0) return thumbByW;
    var chrome = inWizard ? (desktop ? 52 : 78) : desktop ? 32 : 34;
    var rowBudget = Math.floor((height - Math.max(0, rows - 1) * g) / rows) - chrome;
    var minThumb = desktop ? 52 : cols >= 4 ? 32 : 36;
    return Math.max(minThumb, Math.min(thumbByW, rowBudget));
  }

  function pickVariantGridColumns(count, containerWidth, containerHeight, layout) {
    if (count <= 0) return 1;
    if (count === 1) return 1;
    layout = layout === 'horizontal' ? 'horizontal' : 'stacked';
    var width = containerWidth || 0;
    var height = containerHeight || 0;
    var gap = VARIANT_GRID_GAP_PX;
    var bestCols = 1;
    var bestScore = -Infinity;
    var minColPx = VARIANT_ROW_MIN_PX;
    var maxCols = count;

    if (width > 0) {
      if (layout === 'horizontal' && width < 990) {
        maxCols = Math.min(count, isMobileViewport() ? 2 : 3);
        minColPx = 110;
      } else if (width >= 420 && count >= 6) {
        maxCols = Math.min(count, 4);
      }
    }

    for (var cols = maxCols; cols >= 1; cols--) {
      if (width > 0 && cols * minColPx > width) continue;
      var rows = Math.ceil(count / cols);
      var needH = rows * VARIANT_ROW_MIN_H_PX + Math.max(0, rows - 1) * gap;
      if (height > 0 && needH > height) continue;
      var lastRow = count % cols || cols;
      var fullness = lastRow / cols;
      var score = fullness * 400 + cols * 28 - rows * 18;
      if (width >= 420 && count >= 6 && cols >= 4) score += 120;
      if (height > 0) score += (height - needH) * 0.35;
      if (score > bestScore) {
        bestScore = score;
        bestCols = cols;
      }
    }
    return Math.max(1, bestCols);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function carouselMaxScroll(wrap) {
    if (!wrap) return 0;
    return Math.max(0, wrap.scrollWidth - wrap.clientWidth);
  }

  function getCarouselOffset(wrap) {
    if (!wrap) return 0;
    if (typeof wrap.__wbwCarouselOffset === 'number') return wrap.__wbwCarouselOffset;
    return wrap.scrollLeft || 0;
  }

  function setCarouselOffset(wrap, left) {
    if (!wrap) return 0;
    var clamped = Math.max(0, Math.min(carouselMaxScroll(wrap), left));
    wrap.__wbwCarouselOffset = clamped;
    wrap.scrollLeft = clamped;
    try {
      wrap.dispatchEvent(new Event('scroll'));
    } catch (err) {}
    return clamped;
  }

  function prepareVariantCarouselMount(wrap, count) {
    applyVariantCarouselLayout(wrap, count);
    var legacyTrack = wrap.querySelector(':scope > .wbw-variant-carousel-track');
    if (legacyTrack) legacyTrack.remove();
    wrap.innerHTML = '';
    setCarouselOffset(wrap, 0);
    return wrap;
  }

  function carouselSlideScrollLeft(wrap, row) {
    if (!wrap || !row) return 0;
    var maxScroll = carouselMaxScroll(wrap);
    var rows = wrap.querySelectorAll('.wcf-variant-row');
    var isLast = rows.length && rows[rows.length - 1] === row;
    if (isLast) {
      /* Last card flush right — previous peeks on the left. */
      return maxScroll;
    }
    /* Other cards: flush-left snap target — next peeks on the right. */
    return Math.max(0, Math.min(maxScroll, row.offsetLeft || 0));
  }

  function pinCarouselToRow(wrap, row) {
    if (!wrap || !wrap.classList.contains('wcf-variants--carousel')) return;
    var target = row || wrap.querySelector('.wcf-variant-row');
    var left = target ? carouselSlideScrollLeft(wrap, target) : 0;
    if (wrap.__wbwScrollAnim) {
      cancelAnimationFrame(wrap.__wbwScrollAnim);
      wrap.__wbwScrollAnim = 0;
    }
    setCarouselOffset(wrap, left);
  }

  function animateCarouselScrollLeft(el, toLeft, durationMs) {
    if (!el) return;
    var to = Math.max(0, Math.min(carouselMaxScroll(el), toLeft));
    var from = getCarouselOffset(el);
    var delta = to - from;
    if (Math.abs(delta) < 1) return;
    if (el.__wbwScrollAnim) {
      cancelAnimationFrame(el.__wbwScrollAnim);
      el.__wbwScrollAnim = 0;
    }
    var duration = durationMs || 420;
    var start = performance.now();
    function frame(now) {
      var t = Math.min(1, (now - start) / duration);
      setCarouselOffset(el, from + delta * easeOutCubic(t));
      if (t < 1) {
        el.__wbwScrollAnim = requestAnimationFrame(frame);
        return;
      }
      el.__wbwScrollAnim = 0;
      setCarouselOffset(el, to);
    }
    el.__wbwScrollAnim = requestAnimationFrame(frame);
  }

  function bindVariantCarouselTouchScroll(wrap) {
    if (!wrap || wrap.__wbwCarouselTouchBound) return;
    wrap.__wbwCarouselTouchBound = true;

    var AXIS_LOCK = 8;
    var tracking = false;
    var axis = '';
    var startX = 0;
    var startY = 0;
    var startScrollLeft = 0;
    var touchId = null;
    var lastMoveX = 0;
    var lastMoveT = 0;
    var velocityX = 0;
    var rafId = 0;
    var pendingLeft = 0;

    function isInteractiveTarget(t) {
      return !!(
        t &&
        t.closest &&
        t.closest(
          '.wcf-qty--variant, .wbw-stepper, [data-wbw-qty-inc], [data-wbw-qty-dec], [data-wbw-zoom], .wbw-variant-carousel__nav'
        )
      );
    }

    function touchById(list, id) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].identifier === id) return list[i];
      }
      return null;
    }

    function nearestSlideIndex() {
      var list = wrap.querySelectorAll('.wcf-variant-row');
      if (!list.length) return 0;
      var left = getCarouselOffset(wrap);
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < list.length; i++) {
        var dist = Math.abs(carouselSlideScrollLeft(wrap, list[i]) - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function finishHorizontalGesture() {
      var list = wrap.querySelectorAll('.wcf-variant-row');
      if (!list.length) return;
      var idx = nearestSlideIndex();
      var left = getCarouselOffset(wrap);
      var slideW = list[0] ? list[0].offsetWidth : 0;
      var currentLeft = carouselSlideScrollLeft(wrap, list[idx]);

      if (velocityX < -0.2) idx = Math.min(list.length - 1, idx + 1);
      else if (velocityX > 0.2) idx = Math.max(0, idx - 1);
      else if (slideW > 0 && left - currentLeft > slideW * 0.14 && idx < list.length - 1) idx++;
      else if (slideW > 0 && currentLeft - left > slideW * 0.14 && idx > 0) idx--;

      wrap.__wbwSwipeEndAt = Date.now();
      var duration = Math.abs(velocityX) > 0.35 ? 300 : 420;
      animateCarouselScrollLeft(wrap, carouselSlideScrollLeft(wrap, list[idx]), duration);
    }

    function flushPendingScroll() {
      rafId = 0;
      setCarouselOffset(wrap, pendingLeft);
    }

    function resetGesture() {
      tracking = false;
      axis = '';
      touchId = null;
      velocityX = 0;
      lastMoveX = 0;
      lastMoveT = 0;
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
      }
    }

    function onTouchStart(e) {
      if (!isMobileViewport()) return;
      if (e.touches.length !== 1) return;
      if (isInteractiveTarget(e.target)) return;
      if (wrap.__wbwScrollAnim) {
        cancelAnimationFrame(wrap.__wbwScrollAnim);
        wrap.__wbwScrollAnim = 0;
      }
      var t = e.touches[0];
      tracking = true;
      axis = '';
      touchId = t.identifier;
      startX = t.clientX;
      startY = t.clientY;
      startScrollLeft = getCarouselOffset(wrap);
      lastMoveX = t.clientX;
      lastMoveT = e.timeStamp || performance.now();
      velocityX = 0;
    }

    function onTouchMove(e) {
      if (!tracking || touchId == null) return;
      var t = touchById(e.touches, touchId);
      if (!t) return;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;

      if (!axis) {
        if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
        axis = Math.abs(dx) > Math.abs(dy) * 1.05 ? 'x' : 'y';
        if (axis === 'y') {
          resetGesture();
          return;
        }
      }

      if (axis === 'x') {
        e.preventDefault();
        var now = e.timeStamp || performance.now();
        var dt = now - lastMoveT;
        if (dt > 0) velocityX = (t.clientX - lastMoveX) / dt;
        lastMoveX = t.clientX;
        lastMoveT = now;
        pendingLeft = startScrollLeft - dx;
        if (!rafId) {
          rafId = requestAnimationFrame(flushPendingScroll);
        }
      }
    }

    function onTouchEnd(e) {
      var wasHorizontal = axis === 'x';
      if (tracking && touchId != null) {
        var ended = touchById(e.changedTouches, touchId);
        if (!ended && !wasHorizontal) return;
      }
      if (wasHorizontal && rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
        flushPendingScroll();
      }
      resetGesture();
      if (wasHorizontal) finishHorizontalGesture();
    }

    /* Touch-first: Samsung Edge/Android often mishandle pointer capture. */
    wrap.addEventListener('touchstart', onTouchStart, { passive: true });
    wrap.addEventListener('touchmove', onTouchMove, { passive: false });
    wrap.addEventListener('touchend', onTouchEnd, { passive: true });
    wrap.addEventListener('touchcancel', onTouchEnd, { passive: true });
  }

  function syncVariantCarouselNav(wrap) {
    var carousel = wrap && wrap.closest('[data-wbw-variant-carousel]');
    if (!carousel) return;
    var prev = carousel.querySelector('[data-wbw-variant-prev]');
    var next = carousel.querySelector('[data-wbw-variant-next]');
    var rows = wrap.querySelectorAll('.wcf-variant-row');
    var show = rows.length > 1;
    if (prev) {
      prev.hidden = !show;
      if (!show) prev.disabled = true;
    }
    if (next) {
      next.hidden = !show;
      if (!show) next.disabled = true;
    }
    if (!show) return;

    function updateEdgeState() {
      var maxScroll = carouselMaxScroll(wrap);
      var left = getCarouselOffset(wrap);
      var atStart = left <= 2;
      var atEnd = left >= maxScroll - 2;
      if (prev) {
        prev.disabled = atStart;
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (next) {
        next.disabled = atEnd;
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
    }

    function nearestSlideIndex() {
      var list = wrap.querySelectorAll('.wcf-variant-row');
      var left = getCarouselOffset(wrap);
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < list.length; i++) {
        var dist = Math.abs(carouselSlideScrollLeft(wrap, list[i]) - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function slideBy(dir) {
      if (dir < 0 && prev && prev.disabled) return;
      if (dir > 0 && next && next.disabled) return;
      var list = wrap.querySelectorAll('.wcf-variant-row');
      if (!list.length) return;
      var idx = Math.max(0, Math.min(list.length - 1, nearestSlideIndex() + dir));
      var target = list[idx];
      if (!target) return;
      animateCarouselScrollLeft(wrap, carouselSlideScrollLeft(wrap, target), 440);
      window.setTimeout(updateEdgeState, 460);
    }

    updateEdgeState();

    if (!wrap.__wbwCarouselBound) {
      wrap.__wbwCarouselBound = true;
      wrap.addEventListener('scroll', updateEdgeState, { passive: true });
      if (prev) {
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          slideBy(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function (e) {
          e.preventDefault();
          slideBy(1);
        });
      }
    }
  }

  function applyVariantCarouselLayout(wrap, count) {
    if (!wrap || count < 1) return;
    wrap.classList.add('wcf-variants--carousel');
    wrap.classList.remove(
      'wcf-variants--fit',
      'wcf-variants--compact',
      'wcf-variants--layout-stacked',
      'wcf-variants--layout-horizontal'
    );
    wrap.style.removeProperty('--wcf-variant-cols');
    wrap.style.removeProperty('--wcf-variant-rows');
    wrap.style.removeProperty('--wcf-variant-thumb');
    wrap.removeAttribute('data-wcf-cols');
    wrap.removeAttribute('data-wcf-rows');
    wrap.removeAttribute('data-wcf-density');
    wrap.style.setProperty('--wcf-variant-gap', '0.3rem');
    bindVariantCarouselTouchScroll(wrap);
    syncVariantCarouselNav(wrap);
  }

  function clearVariantCarouselLayout(wrap) {
    if (!wrap) return;
    wrap.classList.remove('wcf-variants--carousel');
    var carousel = wrap.closest('[data-wbw-variant-carousel]');
    if (!carousel) return;
    var prev = carousel.querySelector('[data-wbw-variant-prev]');
    var next = carousel.querySelector('[data-wbw-variant-next]');
    if (prev) prev.hidden = true;
    if (next) next.hidden = true;
  }

  function applyVariantGridLayout(wrap, count, wizardRoot) {
    if (!wrap || count < 1) return;
    var isWizardVariants = wrap.hasAttribute('data-wbw-variants');
    /* Carousel / large single-slide layout is mobile-only. */
    if (isWizardVariants && isMobileViewport()) {
      applyVariantCarouselLayout(wrap, count);
      return;
    }
    if (isWizardVariants) clearVariantCarouselLayout(wrap);

    var body = wrap.closest('.wcf-step__body--variants-booking');
    var w = wrap.clientWidth || 0;
    var h = 0;
    if (body) {
      h = body.clientHeight || 0;
      if (!h && body.getBoundingClientRect) h = body.getBoundingClientRect().height;
      if (!w) w = body.clientWidth || 0;
      var inWizardBody = wizardRoot && wizardRoot.contains(body);
      var bottomReserve = inWizardBody ? 172 : 0;
      if (inWizardBody) {
        var topEl = body.querySelector('.wbw-variants-booking-top');
        var topH = 0;
        if (topEl) {
          topH = topEl.clientHeight || 0;
          if (!topH && topEl.getBoundingClientRect) topH = topEl.getBoundingClientRect().height;
        }
        if (topH > 80) {
          h = topH;
        } else {
          var stepEl = body.closest('[data-wbw-step="variants"]');
          var bottomEl = stepEl && stepEl.querySelector('.wbw-variant-step-foot');
          if (bottomEl) {
            var bottomH = bottomEl.offsetHeight || 0;
            if (!bottomH && bottomEl.getBoundingClientRect) bottomH = bottomEl.getBoundingClientRect().height;
            bottomReserve = Math.max(bottomReserve, bottomH);
          }
          h = Math.max(120, h - bottomReserve);
        }
      }
    }
    if (!w && wrap.getBoundingClientRect) w = wrap.getBoundingClientRect().width;

    var layout = variantCardLayout(wizardRoot);
    var gap = layout === 'stacked' ? variantGridGapPx() : VARIANT_GRID_GAP_PX;
    var cols =
      layout === 'stacked'
        ? pickStackedGridColumns(count, w || 320, h, gap, wizardRoot)
        : pickVariantGridColumns(count, w || 320, h, layout);
    var rows = Math.ceil(count / cols);
    wrap.style.setProperty('--wcf-variant-cols', String(cols));
    wrap.style.setProperty('--wcf-variant-rows', String(rows));
    wrap.setAttribute('data-wcf-cols', String(cols));
    wrap.setAttribute('data-wcf-rows', String(rows));
    wrap.classList.toggle('wcf-variants--layout-stacked', layout === 'stacked');
    wrap.classList.toggle('wcf-variants--layout-horizontal', layout === 'horizontal');

    var compact = layout === 'horizontal' && w > 0 && w < 990;
    wrap.classList.toggle('wcf-variants--compact', compact);

    if (layout === 'stacked' && w > 0) {
      var thumbPx = stackedThumbPx(cols, w, h, count, gap, wizardRoot);
      wrap.style.setProperty('--wcf-variant-gap', gap + 'px');
      wrap.style.setProperty('--wcf-variant-thumb', thumbPx + 'px');
      wrap.setAttribute(
        'data-wcf-density',
        isMobileViewport() ? 'mobile' : isDesktopViewport() ? 'desktop' : 'tablet'
      );
      wrap.classList.remove('wcf-variants--fit');
    } else if (h > 0 && rows > 0 && !compact) {
      var rowH = Math.floor((h - Math.max(0, rows - 1) * gap) / rows);
      var rowMax = wizardRoot && wizardRoot.contains(wrap) ? 108 : 120;
      rowH = Math.max(VARIANT_ROW_MIN_H_PX, Math.min(rowH, rowMax));
      wrap.style.setProperty('--wcf-variant-title-size', rowH < 62 ? '0.5625rem' : rowH < 78 ? '0.625rem' : '0.6875rem');
      wrap.style.setProperty('--wcf-variant-price-size', rowH < 62 ? '0.6875rem' : '0.75rem');
      wrap.style.setProperty('--wcf-variant-pad', rowH < 58 ? '0.16rem' : '0.22rem');
      wrap.classList.add('wcf-variants--fit');
    } else {
      wrap.classList.remove('wcf-variants--fit');
    }
  }

  function bindVariantGridResize(wrap, wizardRoot) {
    if (!wrap) return;
    function relayout() {
      var n = wrap.querySelectorAll('.wcf-variant-row').length;
      if (!n) return;
      if (isMobileViewport() && wrap.classList.contains('wcf-variants--carousel')) return;
      applyVariantGridLayout(wrap, n, wizardRoot);
    }
    if (isMobileViewport()) {
      applyVariantCarouselLayout(wrap, wrap.querySelectorAll('.wcf-variant-row').length || 1);
      return;
    }
    relayout();
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        relayout();
        requestAnimationFrame(relayout);
      });
    }
    window.setTimeout(relayout, 60);
    if (typeof ResizeObserver === 'undefined') return;
    if (wrap.__wbwGridRo) wrap.__wbwGridRo.disconnect();
    var body = wrap.closest('.wcf-step__body--variants-booking');
    wrap.__wbwGridRo = new ResizeObserver(relayout);
    wrap.__wbwGridRo.observe(body || wrap);
    wrap.__wbwGridRo.observe(wrap);
  }

  function variantQtyControlHtml(variantId, qty) {
    var q = qty || 0;
    var id = vQtyKey(variantId);
    var minusSvg =
      '<svg class="wbw-stepper__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M1 12H23" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var plusSvg =
      '<svg class="wbw-stepper__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M1 12H23M12 1V23" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return (
      '<div class="wbw-stepper" data-wbw-variant-qty data-variant-id="' +
      id +
      '">' +
      '<button type="button" class="wbw-stepper__btn" data-wbw-qty-dec aria-label="' + __amcT('Decrease quantity') + '"' +
      (q <= 0 ? ' disabled' : '') +
      '>' +
      minusSvg +
      '</button>' +
      '<span class="wbw-stepper__val" data-wbw-qty-val aria-live="polite">' +
      q +
      '</span>' +
      '<button type="button" class="wbw-stepper__btn" data-wbw-qty-inc aria-label="' + __amcT('Increase quantity') + '">' +
      plusSvg +
      '</button></div>'
    );
  }

  /** Shop-wizard qty chrome (Add → stepper) for hub store venue path only. */
  function storeShopVariantQtyControlHtml(variantId, qty) {
    var q = qty || 0;
    var id = vQtyKey(variantId);
    var empty = q <= 0;
    return (
      '<div class="wcf-qty wcf-qty--variant' +
      (empty ? ' is-empty' : '') +
      '" data-wbw-variant-qty data-wcf-variant-qty data-variant-id="' +
      id +
      '">' +
      '<button type="button" class="wcf-qty__add" data-wcf-qty-add data-wbw-qty-add' +
      (empty ? '' : ' hidden') +
      '>' +
      __amcT('Add') +
      '</button>' +
      '<div class="wcf-qty__stepper" data-wcf-qty-stepper' +
      (empty ? ' hidden' : '') +
      '>' +
      '<button type="button" class="wcf-qty__btn" data-wbw-qty-dec data-wcf-qty-dec aria-label="' +
      __amcT('Decrease quantity') +
      '"' +
      (q <= 0 ? ' disabled' : '') +
      '>−</button>' +
      '<span class="wcf-qty__val" data-wbw-qty-val data-wcf-qty-val aria-live="polite">' +
      q +
      '</span>' +
      '<button type="button" class="wcf-qty__btn" data-wbw-qty-inc data-wcf-qty-inc aria-label="' +
      __amcT('Increase quantity') +
      '">+</button>' +
      '</div></div>'
    );
  }
  H.prepareVariantCarouselMount = prepareVariantCarouselMount;
  H.getCarouselOffset = getCarouselOffset;
  H.setCarouselOffset = setCarouselOffset;
  H.animateCarouselScrollLeft = animateCarouselScrollLeft;
  H.applyVariantCarouselLayout = applyVariantCarouselLayout;
  H.applyVariantGridLayout = applyVariantGridLayout;
  H.bindTimeDdReposition = bindTimeDdReposition;
  H.bindVariantGridResize = bindVariantGridResize;
  H.bindWizardSearchLayout = bindWizardSearchLayout;
  H.carouselSlideScrollLeft = carouselSlideScrollLeft;
  H.cleanupOrphanTimeDdPanels = cleanupOrphanTimeDdPanels;
  H.clearVariantCarouselLayout = clearVariantCarouselLayout;
  H.closeImpulseProductZoom = closeImpulseProductZoom;
  H.easeOutCubic = easeOutCubic;
  H.ensureTimeDdPortal = ensureTimeDdPortal;
  H.ensureVariantMediaMeta = ensureVariantMediaMeta;
  H.findImpulseMediaSlide = findImpulseMediaSlide;
  H.findShopifyVariantByWizard = findShopifyVariantByWizard;
  H.findStyleFieldset = findStyleFieldset;
  H.getCalTimeDdParts = getCalTimeDdParts;
  H.getProductContainer = getProductContainer;
  H.getSectionRoot = getSectionRoot;
  H.goToImpulseVariantMedia = goToImpulseVariantMedia;
  H.goToZoomGalleryByMediaId = goToZoomGalleryByMediaId;
  H.isDesktopViewport = isDesktopViewport;
  H.isMobileViewport = isMobileViewport;
  H.isSessionOptionHandle = isSessionOptionHandle;
  H.normalizeOptionValue = normalizeOptionValue;
  H.openImpulseProductZoom = openImpulseProductZoom;
  H.openWizardVariantImageFallback = openWizardVariantImageFallback;
  H.parseVariantsJson = parseVariantsJson;
  H.parseZoomSlideMediaId = parseZoomSlideMediaId;
  H.parseZoomThumbMediaId = parseZoomThumbMediaId;
  H.pickStackedGridColumns = pickStackedGridColumns;
  H.pickVariantGridColumns = pickVariantGridColumns;
  H.pinCarouselToRow = pinCarouselToRow;
  H.positionTimeDdPanel = positionTimeDdPanel;
  H.raiseImpulseProductModal = raiseImpulseProductModal;
  H.resetTimeDdPanelStyle = resetTimeDdPanelStyle;
  H.resolveImpulseMediaZoomPosition = resolveImpulseMediaZoomPosition;
  H.stackedThumbPx = stackedThumbPx;
  H.styleValueFromVariant = styleValueFromVariant;
  H.syncImpulseMasterVariantId = syncImpulseMasterVariantId;
  H.syncImpulseOptionsByVariant = syncImpulseOptionsByVariant;
  H.syncImpulseStyleOption = syncImpulseStyleOption;
  H.syncVariantCarouselNav = syncVariantCarouselNav;
  H.syncVariantToPdp = syncVariantToPdp;
  H.timeDdPortalEl = timeDdPortalEl;
  H.variantCardLayout = variantCardLayout;
  H.variantGridColsCap = variantGridColsCap;
  H.variantGridGapPx = variantGridGapPx;
  H.variantQtyControlHtml = variantQtyControlHtml;
  H.storeShopVariantQtyControlHtml = storeShopVariantQtyControlHtml;
  H.venueHasBookableEvents = venueHasBookableEvents;
  H.venueHasVisibleEvents = venueHasVisibleEvents;
  H.venueIsWaitlistOnly = venueIsWaitlistOnly;
  H.wbwAddonDisplayTitle = wbwAddonDisplayTitle;
  H.wbwEmitVenueReset = wbwEmitVenueReset;
})(typeof window !== "undefined" ? window : this);
